import DefaultLayout from 'layouts/default';
import './index.css';
import LoginForm from 'components/LoginForm';
const LoginPage = () => {
  return (
    <DefaultLayout>
      <div className="LoginPage">
        <LoginForm />
      </div>
    </DefaultLayout>
  );
};

export default LoginPage;
